import { LanguageLevelEnum } from "../enums";

export const ENGLISH_LANGUAGE = 'EN';
export const GERMAN_LANGUAGE = 'DE';
export const DEFAULT_LANGUAGE = GERMAN_LANGUAGE;

export const LANGUAGE_LEVELS_SORTED
  = [LanguageLevelEnum.FIRST_LANGUAGE, LanguageLevelEnum.FLUENT, LanguageLevelEnum.MODERATE, LanguageLevelEnum.BEGINNER];

